import types from "../types";

const initialState = {
  pendingDeleteIDs: {},
};

export const creativeTemplatesReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case types.CREATIVE_TEMPLATES_HIDE_PENDING_DELETE: {
      const templateID = String(payload?.templateID || "").trim();
      if (!templateID || state.pendingDeleteIDs[templateID]) {
        return state;
      }
      return {
        ...state,
        pendingDeleteIDs: {
          ...state.pendingDeleteIDs,
          [templateID]: true,
        },
      };
    }
    case types.CREATIVE_TEMPLATES_CLEAR_PENDING_DELETE: {
      const templateID = String(payload?.templateID || "").trim();
      if (!templateID || !state.pendingDeleteIDs[templateID]) {
        return state;
      }
      const pendingDeleteIDs = { ...state.pendingDeleteIDs };
      delete pendingDeleteIDs[templateID];
      return {
        ...state,
        pendingDeleteIDs,
      };
    }
    case types.CREATIVE_TEMPLATES_PRUNE_PENDING_DELETES: {
      const existingIDs = new Set(payload?.existingIDs || []);
      let changed = false;
      const pendingDeleteIDs = {};
      Object.keys(state.pendingDeleteIDs).forEach((templateID) => {
        if (existingIDs.has(templateID)) {
          pendingDeleteIDs[templateID] = true;
          return;
        }
        changed = true;
      });
      if (!changed) {
        return state;
      }
      return {
        ...state,
        pendingDeleteIDs,
      };
    }
    case types.GLOBAL_RESET_STATE:
    case types.GLOBAL_RESET_ADVERTISER_DATA:
      return initialState;
    default:
      return state;
  }
};
